import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Divider } from "@material-ui/core";
import api from "../../../../../../services/api";
import SyncLoader from "react-spinners/SyncLoader";
import { format } from "date-fns";
import { useAuth } from "../../../../../../hooks/auth";
import * as Dialog from "@radix-ui/react-dialog";
import { useRoutes } from "../../../../../../hooks/routes";

import IListShapesCategoryApiProps from "./dtos/IListShapesCategoryApiProps";
import ICreatorAndEditorProps from "./dtos/ICreatorAndEditorProps";

import MasterAsideControls from "../../../../components/SidebarMaster/MasterAsideControls";
import HeaderMaster from "../../../../components/SidebarMaster/HeaderMaster";
import MasterContainer from "../../../../components/SidebarMaster/MasterContainer";
import MasterMain from "../../../../components/SidebarMaster/MasterMain";

import Button from "../../../../../../shared/components/Button";
import DialogModal from "../../../../../../shared/components/DialogModal";

import { Notify } from "../../../../../../shared/utils";

import {
  Container,
  Title,
  Subtitle,
  ContainerLoading,
  ContainerButton,
} from "./styles";

const ViewShapesCategory: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [creator, setCreator] = useState<ICreatorAndEditorProps>({ name: "" });
  const [lastEditor, setLastEditor] = useState<ICreatorAndEditorProps>({
    name: "",
  });
  const [shapesCategoryData, setShapesCategoryData] =
    useState<IListShapesCategoryApiProps>({
      id: "",
      creator_id: "",
      last_editor_id: "",
      title: "",
      description: "",
      created_at: new Date(),
      updated_at: new Date(),
    });

  const location = useLocation();
  const dataLocation: any = location.state;

  const { data: dataUseAuth } = useAuth();

  const { getUrl } = useRoutes();

  const userPermissionReadUser = dataUseAuth.admin_user_permissions.read_users;

  const userPermissionUpdate =
    dataUseAuth.admin_user_permissions.update_shapes_categories;
  const userPermissionDelete =
    dataUseAuth.admin_user_permissions.delete_shapes_categories;

  const { shape_category_id } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    getUrl("/view-shapes-category/:shape_category_id");
  }, []);

  useEffect(() => {
    (async () => {
      const listShapesCategorySpecific = await api.get(
        `/bits-shape-category/${shape_category_id}`
      );

      if (userPermissionReadUser) {
        const userCreator = await api.get(
          `/profile/${listShapesCategorySpecific.data.creator_id}`
        );

        const userLastEditor = await api.get(
          `/profile/${listShapesCategorySpecific.data.last_editor_id}`
        );

        setCreator({
          name: `${userCreator.data.people.first_name} ${userCreator.data.people.last_name}`,
        });
        setLastEditor({
          name: `${userLastEditor.data.people.first_name} ${userLastEditor.data.people.last_name}`,
        });
      } else {
        setCreator({
          name: "Anônimo",
        });
        setLastEditor({
          name: "Anônimo",
        });
      }

      setShapesCategoryData(listShapesCategorySpecific.data);
      setLoading(false);
    })();
  }, [shape_category_id, userPermissionReadUser]);

  const handleDeleteShapeCategory = useCallback(
    async (id: string) => {
      await api.delete(`/bits-shape-category/${id}`);
      Notify({
        text: "Categoria de formas deletada com sucesso",
        type: "success",
      });
      navigate("/shapes-category", {
        state: { params: dataLocation?.params },
      });
    },
    [navigate, dataLocation]
  );

  return (
    <MasterContainer>
      <MasterAsideControls />
      <HeaderMaster namePage="Visualizar categoria de formas" />
      <MasterMain>
        {loading && (
          <ContainerLoading>
            <SyncLoader loading={loading} color="#663399" size={10} />
          </ContainerLoading>
        )}

        {!loading && (
          <Container>
            <Title>Título:</Title>
            <Subtitle>
              {shapesCategoryData.title ? shapesCategoryData.title : "null"}
            </Subtitle>

            <Title>Descrição:</Title>
            <Subtitle>
              {shapesCategoryData.description
                ? shapesCategoryData.description
                : "null"}
            </Subtitle>

            <Title>Criador:</Title>
            <Subtitle>{creator.name}</Subtitle>

            <Title>Último a editar:</Title>
            <Subtitle>{lastEditor.name}</Subtitle>

            <Title>Criado em:</Title>
            <Subtitle>
              {`${new Date(shapesCategoryData.created_at)}`
                ? `${format(
                    new Date(shapesCategoryData.created_at),
                    "dd/MM/yyyy HH:mm"
                  )}`
                : "null"}
            </Subtitle>

            <Title>Última atualização:</Title>
            <Subtitle>
              {`${new Date(shapesCategoryData.updated_at)}`
                ? `${format(
                    new Date(shapesCategoryData.updated_at),
                    "dd/MM/yyyy HH:mm"
                  )}`
                : "null"}
            </Subtitle>

            <Divider style={{ marginBottom: 20, marginTop: 20 }} />

            <ContainerButton>
              <Button
                style={{ width: 100 }}
                onClick={() =>
                  navigate("/shapes-category", {
                    state: { params: dataLocation?.params },
                  })
                }
              >
                Voltar
              </Button>

              <Button
                style={{ width: 100, marginLeft: 20 }}
                onClick={() =>
                  navigate(`/edit-shapes-category/${shape_category_id}`, {
                    state: { params: dataLocation?.params },
                  })
                }
                disabled={!userPermissionUpdate}
              >
                Editar
              </Button>

              <Dialog.Root>
                <Dialog.Trigger asChild>
                  <Button
                    style={{ width: 100, marginLeft: 20 }}
                    disabled={!userPermissionDelete}
                  >
                    Excluir
                  </Button>
                </Dialog.Trigger>

                <DialogModal
                  title="Deletar categoria de formas"
                  type="delete"
                  subtitle={shapesCategoryData.title}
                  callback={() =>
                    handleDeleteShapeCategory(shapesCategoryData.id)
                  }
                />
              </Dialog.Root>
            </ContainerButton>
          </Container>
        )}
      </MasterMain>
    </MasterContainer>
  );
};

export default ViewShapesCategory;
